import Paper from '@material-ui/core/Paper';
import {makeStyles} from '@material-ui/core/styles';
import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import authFetch from 'helpers/requests';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  TextField,
  Button,
  Snackbar,
} from '@material-ui/core';
import {Form, Formik} from 'formik';
import Trans from '@lingui/core';
import {i18n2} from 'features/i18n/i18n';
import Signature from 'components/Editors/Signature';
import useUser from 'components/GenericsHooks/useUser';

const useStyles = makeStyles((theme) => ({
  MuiTableCellBody: {
    paddingBottom: '5px !important',
    paddingTop: '5px !important',
  },
  paper: {
    padding: 10,
  },
}));

const TakeAssistance = ({id, close, id_course}) => {
  const classes = useStyles();
  const token = useSelector((state) => state.authentication.user.token);
  const [data, setData] = useState([]);
  const userName = useUser();
  const [message, setMessage] = React.useState({
    text: '',
    open: false,
    succesful: false,
  });

  useEffect(() => {
    authFetch(
      `api/attended/getAttendedInPerson?id=${id}&id_course=${id_course}`,
      {mode: 'cors'},
      token,
    )
      .then((response) => response.json())
      .then((x) => {
        if (x) {
          x.forEach((el) => {
            el.score = el.score * 100;
          });
          setData(x);
        }
      })
      .catch((e) => {
        return {};
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const changeChecked = (index) => {
    let collab = [...data];
    collab[index].present = !collab[index].present;
    setData(collab);
  };

  const changeScore = (index, score) => {
    if (score >= 0 && score <= 100) {
      let collab = [...data];
      collab[index].score = score.replace('/^[0-9]+$/', '');
      if (score === '') {
        collab[index].score = 0;
      }
      setData(collab);
    }
  };

  const closeSnackbar = () => {
    setMessage({...message, open: false});
    close();
    // update(false)
  };

  const submit = (values) => {
    values = {
      ...values,
      data,
      user: userName,
    };
    return authFetch(
      `api/Attended/attendedInPerson`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
        },
        body: JSON.stringify(JSON.stringify(values)),
      },
      token,
    )
      .then((response) => {
        if (response.ok) {
          setMessage({
            text: i18n2._('Operación terminada exitosamente'),
            open: true,
            succesful: true,
          });
          // update(true)
        } else {
          response
            .text()
            .then((message) =>
              setMessage({text: message, open: true, succesful: false}),
            );
        }
      })
      .catch((error) => console.log(error));
  };

  return (
    <>
      <Paper className={classes.paper} elevation={0}>
        <h2 style={{marginTop: '1%'}}>{i18n2._('Tomar asistencia')}</h2>
        {data ? (
          <>
            <TableContainer component={Paper}>
              <Table aria-label="simple table" stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell>{i18n2._('Nombre')}</TableCell>
                    <TableCell>{i18n2._('Asistencia')}</TableCell>
                    <TableCell>{i18n2._('Puntaje (%)')}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.map((e, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell
                          component="th"
                          scope="row"
                          className={classes.MuiTableCellBody}>
                          {e.name}
                        </TableCell>
                        <TableCell className={classes.MuiTableCellBody}>
                          <Checkbox
                            checked={e.present}
                            onChange={() => changeChecked(index)}
                            inputProps={{'aria-label': 'primary checkbox'}}
                          />
                        </TableCell>
                        <TableCell className={classes.MuiTableCellBody}>
                          <TextField
                            value={e.score}
                            size="small"
                            onChange={(event) =>
                              changeScore(index, event.target.value)
                            }
                            inputProps={{
                              size: 3,
                            }}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
            <Formik
              initialValues={{
                user: userName,
                pass: '',
                reason: '',
                finished: false,
              }}
              onSubmit={submit}
              validateOnChange
              enableReinitialize>
              {(formikProps) => (
                <Form>
                  <Signature user={userName} touched={formikProps.touched} />
                  <div style={{float: 'right', padding: 10}}>
                    <Button onClick={() => close()} style={{color: 'red'}}>
                      {i18n2._('Cancel')}
                    </Button>
                    <Button
                      type="submit"
                      color="primary"
                      disabled={formikProps.isSubmitting}>
                      {i18n2._('Guardar')}
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </>
        ) : (
          <Trans>No hay asistentes</Trans>
        )}
      </Paper>
      <Snackbar
        open={message.open}
        autoHideDuration={1000}
        onClose={() =>
          message.succesful
            ? closeSnackbar()
            : setMessage({...message, open: false})
        }
        message={i18n2._(message.text ? message.text : '')}
      />
    </>
  );
};

export default TakeAssistance;
